/* ===== TYPEWRITER SEARCH JS ===== */
document.addEventListener('DOMContentLoaded', function() {

  /* — Typewriter search — */
  var placeholders = [
    'Search Suffuse...','Search Faiza Saqlain...','Search Aik Atelier...',
    'Search Hussain Rehar...','Search Zara Shahjahan...','Search Maria B...',
    'Search Asim Jofa...','Search Baroque...','Search Crimson...'
  ];
  var inp = document.getElementById('mfSearchInput');
  if (inp) {
    var pi=0,ci=0,deleting=false,ti;
    function tick(){
      var t=placeholders[pi];
      if(!deleting){ inp.placeholder=t.slice(0,++ci);
        if(ci===t.length){deleting=true;clearInterval(ti);setTimeout(function(){ti=setInterval(tick,45);},2000);}
      } else { inp.placeholder=t.slice(0,--ci);
        if(ci===0){deleting=false;pi=(pi+1)%placeholders.length;clearInterval(ti);setTimeout(function(){ti=setInterval(tick,80);},400);}
      }
    }
    setTimeout(function(){ti=setInterval(tick,80);},1000);
  }

  /* — Mobile drawer — */
  var hamburger = document.getElementById('mfHamburger');
  var drawer    = document.getElementById('mfDrawer');
  var overlay   = document.getElementById('mfOverlay');
  var closeBtn  = document.getElementById('mfDrawerClose');

  function openDrawer(){
    drawer.classList.add('open');
    overlay.classList.add('open');
    drawer.setAttribute('aria-hidden','false');
    document.body.style.overflow='hidden';
  }
  function closeDrawer(){
    drawer.classList.remove('open');
    overlay.classList.remove('open');
    drawer.setAttribute('aria-hidden','true');
    document.body.style.overflow='';
  }

  if(hamburger) hamburger.addEventListener('click', openDrawer);
  if(closeBtn)  closeBtn.addEventListener('click',  closeDrawer);
  if(overlay)   overlay.addEventListener('click',   closeDrawer);

  /* — Accordion sub-menus — */
  document.querySelectorAll('.mf-acc-btn').forEach(function(btn){
    btn.addEventListener('click', function(){
      var targetId = this.getAttribute('data-target');
      var sub = document.getElementById(targetId);
      var chevron = this.querySelector('.mf-drawer-chevron');
      var isOpen = sub.classList.contains('open');

      /* close all others */
      document.querySelectorAll('.mf-sub-menu.open').forEach(function(s){ s.classList.remove('open'); });
      document.querySelectorAll('.mf-drawer-chevron.open').forEach(function(c){ c.classList.remove('open'); });

      if(!isOpen){
        sub.classList.add('open');
        chevron.classList.add('open');
      }
    });
  });

});

/* Mobile search typewriter */
(function() {
  var el = document.getElementById('mfMobileSearchInput');
  if (!el || window.innerWidth >= 990) return;
  var words = [
    'Search Suffuse...','Search Soraya...','Search Faiza Saqlain...',
    'Search Aik Atelier...','Search Maria B...','Search Hussain Rehar...',
    'Search Asim Jofa...','Search Zara Shahjahan...','Search Baroque...',
    'Search Rang Rasiya...','Search Crimson...'
  ];
  var wi=0,ci=0,del=false,t;
  function run(){
    var w=words[wi];
    if(!del){el.placeholder=w.slice(0,++ci);
      if(ci===w.length){del=true;clearInterval(t);setTimeout(function(){t=setInterval(run,40);},2200);return;}
    }else{el.placeholder=w.slice(0,--ci);
      if(ci===0){del=false;wi=(wi+1)%words.length;clearInterval(t);setTimeout(function(){t=setInterval(run,85);},350);return;}
    }
  }
  setTimeout(function(){t=setInterval(run,85);},1500);
})();

/* ===== MAKE ENTIRE PRODUCT CARD CLICKABLE ===== */
(function() {
  function initCardClicks() {
    document.querySelectorAll('.card-wrapper, .card--standard, .card').forEach(function(card) {
      if (card.dataset.mfClickable) return;
      card.dataset.mfClickable = 'true';

      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      var href = link.getAttribute('href');

      card.style.cursor = 'pointer';

      card.addEventListener('click', function(e) {
        if (e.target.closest('button')) return;
        if (e.target.closest('.mf-wish-btn')) return;
        if (e.target.closest('.quick-add')) return;
        if (e.target.tagName === 'A') return;
        window.location.href = href;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCardClicks);
  } else {
    initCardClicks();
  }

  /* Re-init after Shopify AJAX filter/pagination changes */
  var observer = new MutationObserver(function() {
    setTimeout(initCardClicks, 300);
  });
  var grid = document.getElementById('ProductGridContainer') ||
             document.querySelector('.collection') ||
             document.querySelector('.product-grid');
  if (grid) {
    observer.observe(grid, { childList: true, subtree: true });
  }
})();

